import React from 'react';
import PropTypes from 'prop-types';

const EmailInput = ({name, label, subLabel, onChange, className, placeholder, value, error, hideErrorMessage}) => {
    let wrapperClass = 'form-group';
    if(error && error.length > 0){
        wrapperClass += " " + 'has-error';
    }

    return (
        <div className={wrapperClass}>
            <label htmlFor={name}><span>{label}</span></label>
            <div className="field">
                <input
                    type="email"
                    name={name}
                    className={className +' form-control'}
                    placeholder={placeholder}
                    value={value}
                    onChange={onChange}
                />
                {error && typeof hideErrorMessage === 'undefined' && <div className="alert alert-danger">{error}</div>}
            </div>
        </div>
    );
};

EmailInput.propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    subLabel:PropTypes.string,
    onChange: PropTypes.func.isRequired,
    className:PropTypes.string,
    placeholder: PropTypes.string,
    value: PropTypes.string,
    error: PropTypes.string,
    hideErrorMessage:PropTypes.string
};

export default EmailInput;



/** WEBPACK FOOTER **
 ** ./src/components/form/EmailInput.js
 **/